import { Component, OnInit } from '@angular/core';
import { NgRedux, Select, Select$ } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { Media, Playlist } from '../../store/entities';
import { APlayFromPlaylist, PlaylistRemoteAppState } from '../../store';
import { toArray } from '../../utils';

@Component({
  selector: 'mwo-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})
export class  WishlistPage implements OnInit {
  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select('wishlist') wishlist$: Observable<Playlist>;
  @Select$(['wishlist', 'assoMediaEvent'], toArray) wishlistTracks$: Observable<Media[]>;
  wishlist: Playlist = {};

  constructor(private ngRedux: NgRedux<PlaylistRemoteAppState>) { }

  ngOnInit(): void {
    this.wishlist$.subscribe(wishlist => {
      this.wishlist = wishlist;
    });
  }

  play(id: string) {
    this.ngRedux.dispatch(APlayFromPlaylist({ event: { id }, playerContextType: 'PLAYLIST' }));
  }
}
